import Confirm from 'components/confirm';
import { MODAL_PREFIX } from '../../constants.js';
import React from 'react';

class DeleteUser extends React.Component {
  /**
   * @params props.organization
   * @params props.user
   */
  constructor(props) {
    super(props);
  }

  render() {
    const { organization, user } = this.props;
    const ownerUrl = Routes.delete_organization_user_path(organization, user);
    return (
      <a
        href={ownerUrl}
        style={{ display: 'inline' }}
        className="delete-user-button"
      >
        Delete
      </a>
    );
  }
}

export default DeleteUser;
